<template>
  <fb-list-body :pager="pager" :showSearchForm="true" :showBtnGroup="false"
                @handlePagerSizeChange="handlePagerSizeChange" @handlePagerIndexChange="handlePagerIndexChange">

    <template slot="other">
      <div style="display: flex">
        <el-button size="medium" type="primary" @click="exportData">{{ $t('lang.导出') }}</el-button>
        <el-button style="margin-left: 14px" icon="el-icon-delete" @click.native="handleBatchDelete">{{ $t('lang.删除') }}</el-button>
      </div>

    </template>
    <template slot="search-form">
      <div @keyup.enter="handleSearch">
        <el-form-item class="search-form-item" :label="$t('lang.搜索内容')">
          <el-input :placeholder="$t('lang.搜索内容')" v-model="searchForm.content" clearable></el-input>
        </el-form-item>

        <el-form-item class="search-form-item" :label="$t('lang.搜索类型')">
          <el-select :placeholder="$t('lang.搜索类型')" clearable v-model="searchForm.type">
            <el-option :label="$t('lang.输入')" value="input"></el-option>
            <el-option :label="$t('lang.标签')" value="tag"></el-option>
          </el-select>
        </el-form-item>


        <el-form-item class="search-form-item" :label="$t('lang.时间')">
          <el-date-picker
              v-model="time"
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              range-separator="~"
              :start-placeholder="$t('lang.开始日期')"
              :end-placeholder="$t('lang.结束日期')">
          </el-date-picker>
        </el-form-item>

        <el-form-item class="search-form-item" label="">
          <el-button size="mini" type="primary" icon="el-icon-search" @click.stop="handleSearch">{{ $t('lang.搜索') }}</el-button>
          <el-button size="mini" type="primary" @click="handleReset">{{ $t('lang.重置') }}</el-button>
        </el-form-item>
      </div>

    </template>


    <template slot="table">
      <el-table :data="tableData" @selection-change="handleSelectionChange">

        <el-table-column type="selection" width="50"></el-table-column>

        <el-table-column type="index" width="50" :label="$t('lang.序号')"></el-table-column>
        <el-table-column prop="typeName" :label="$t('lang.搜索类型')"></el-table-column>
        <el-table-column prop="content" :label="$t('lang.搜索内容')"></el-table-column>
        <el-table-column prop="resultCount" :label="$t('lang.搜索结果数')"></el-table-column>
        <el-table-column prop="userNumber" :label="$t('lang.用户编号')"></el-table-column>
        <el-table-column prop="createTimeStr" :label="$t('lang.时间')"></el-table-column>

        <el-table-column fixed="right" :label="$t('lang.操作')">
          <template slot-scope="scope">
            <el-button size="mini" plain type="danger" @click="handleDelete(scope.row)">{{ $t('lang.删除') }}</el-button>
          </template>
        </el-table-column>


      </el-table>

    </template>


  </fb-list-body>
</template>

<script>

export default {
  name: "UserSearchRecordList",
  components: {},
  props: {
    timestamp: {
      type: Number,
      default: function () {
        return new Date().getTime()
      }
    },
  },
  data() {
    return {
      api: {
        list: this.$api.userSearchRecord.list,
        delete: this.$api.userSearchRecord.delete,
        batchDelete: this.$api.userSearchRecord.batchDelete,
        exportData: this.$api.userSearchRecord.exportData,
      },
      brandOwnerCode: '',
      searchForm: {},
      tableData: [],
      selection: [],
      pager: {
        pageSize: 10,
        pageIndex: 1,
        itemCount: 0
      },
      value: [],
      time: '',
    }
  },
  computed: {
    searchParams() {
      return Object.assign({}, this.$route.query, this.searchForm, this.pager);
    }
  },
  watch: {
    time: {
      handler(val) {
        const vm = this;
        if (val.length) {
          vm.searchForm['startTime'] = val[0];
          vm.searchForm['endTime'] = val[1];
        }
      },
      immediate: true,
      deep: true,
    },
    timestamp() {
      this.handleGetData();
    },
    "pager.pageIndex": {
      handler() {
        this.$router.updateQuery({
          path: this.$route.path,
          query: this.searchParams
        });
        this.handleGetData();

      },
      deep: true,
      immediate: true
    },
    "pager.pageSize": {
      handler() {

        this.$router.updateQuery({
          path: this.$route.path,
          query: this.searchParams
        });
        this.handleGetData();

      },
      deep: true
    }

  },
  methods: {
    exportData() {
      console.log('exportData');
      try {
        let downloadElement = document.createElement("a");
        let param = "?brandOwnerCode=" + this.brandOwnerCode;
        downloadElement.href = this.api.exportData + param;
        downloadElement.click();
      } catch (e) {
        console.log("下载文件失败", e);
      }
    },
    handleSearch() {
      this.pager.pageIndex = 1;
      this.pager.pageSize = 10;
      this.pager.itemCount = 0;
      this.handleGetData();
    },
    handleReset() {
      this.time = ''
      if(Object.keys(this.searchForm).length) {
        this.searchForm = {};
        this.pager.pageIndex = 1;
        this.pager.pageSize = 10;
        this.pager.itemCount = 0;
        this.handleGetData();
      }
    },

    handleEdit(e) {

      if (e && e.code) {
        this.$router.push({
          path: 'edit',
          query: {
            code: e.code
          }
        });
        return;
      }

      if (!this.selection.length) {
        this.$message({
          type: 'warning',
          message: this.$t('lang.未选择记录')
        });
        return;
      }

      if (this.selection.length > 1) {
        this.$message({
          type: 'warning',
          message: this.$t('lang.一次只能编辑一条数据')
        });
        return;
      }

      this.$router.push({
        path: 'edit',
        query: {
          code: this.selection[0].code
        }
      });
    },
    handleDelete(row) {


      let vm = this;

      vm.$confirm(vm.$t('lang.您现在正在进行删除操作'), vm.$t('lang.提示'), {
        confirmButtonText: vm.$t('lang.确定'),
        cancelButtonText: vm.$t('lang.取消'),
        type: 'warning'
      }).then(() => {

        vm.$http.post(vm.api.delete, vm.$qs.stringify({
          code: row.code
        })).then((resp) => {
          if (resp.data.status === 200) {
            vm.$message({
              type: 'success',
              message: resp.data.desc
            });
            vm.handleGetData();
          } else {
            vm.$message({
              type: 'error',
              message: resp.data.desc
            });

          }
        })


      }).catch(() => {
        // this.$message({
        //     type: 'info',
        //     message: '已取消删除'
        // });
      });

    },
    handleBatchDelete() {


      let vm = this;

      if (!this.selection.length) {
        this.$message({
          type: 'warning',
          message: vm.$t('lang.未选择记录')
        });
        return;
      }


      let codes = [];

      this.selection.forEach((e) => {
        codes.push(e.code);
      });


      this.$confirm(vm.$t('lang.您现在正在进行删除操作'), vm.$t('lang.提示'), {
        confirmButtonText: vm.$t('lang.确定'),
        cancelButtonText: vm.$t('lang.取消'),
        type: 'warning'
      }).then(() => {

        vm.$http.post(this.api.batchDelete, codes).then((resp) => {
          if (resp.data.status === 200) {
            vm.$message({
              type: 'success',
              message: resp.data.desc
            });
            vm.handleGetData();
          } else {
            vm.$message({
              type: 'error',
              message: resp.data.desc
            });

          }
        })


      }).catch(() => {
        // this.$message({
        //     type: 'info',
        //     message: '已取消删除'
        // });
      });


    },
    handleSelectionChange(selection) {
      console.log(selection);
      this.selection = selection;
    },
    handlePagerSizeChange(e) {
      this.pager.pageSize = e;
    },
    handlePagerIndexChange(e) {
      this.pager.pageIndex = e;
    },
    handleGetData() {
      let vm = this;
      this.searchParams.brandOwnerCode = JSON.parse(sessionStorage.getItem("login-user-info")).brandOwnerCode
      this.$http.post(this.api.list, this.$qs.stringify(this.searchParams)).then((resp) => {


        for (let key in resp.data.data) {
          if (resp.data.data[key] instanceof Array) {
            vm.tableData = resp.data.data[key];
          }
        }

        //处理分页
        vm.pager.pageIndex = resp.data.data.pager.pageIndex;
        vm.pager.pageSize = resp.data.data.pager.pageSize;
        vm.pager.itemCount = resp.data.data.pager.itemCount;

      })
    }
  },
  created() {
    this.brandOwnerCode = this.$store.state.userInfo['brandOwnerCode']
    for (let key in this.searchForm) {
      if (this.$route.query[key]) {
        this.searchForm[key] = this.$route.query[key];
      }
    }
  }
}
</script>

<style scoped>

</style>
